class PP_BlogCategories {
  constructor () {
    this.initEvents();
  }

  initEvents () {
    let wrapper = $('.blog-categories-list');

    if (!wrapper.length) {
      return;
    }

    let toggleButton = wrapper.find('.blog-categories-item-expand');
    let closeButton = wrapper.find('.blog-categories-item-close');
    
    toggleButton.on('click', e => {
      e.preventDefault();
      let hiddenItems = wrapper.find('.blog-categories-item.is-hidden');
      hiddenItems.addClass('is-not-visible').removeClass('is-hidden');

      setTimeout(() => {
        for (let i = 0; i < hiddenItems.length; i++) {
          let element = hiddenItems.eq(i);
          
          setTimeout(() => {
            element.removeClass('is-not-visible');
            element.addClass('is-now-displayed');
          }, i * 25);
        }
      }, 0);

      setTimeout(() => {
        toggleButton.addClass('is-hidden');
        closeButton.removeClass('is-hidden');
      }, 0);
    });

    closeButton.on('click', e => {
      e.preventDefault();
      let itemsToHide = wrapper.find('.blog-categories-item.is-now-displayed');
      itemsToHide.removeClass('is-now-displayed');

      setTimeout(() => {
        for (let i = itemsToHide.length; i > 0; i--) {
          let element = itemsToHide.eq(i);
          
          setTimeout(() => {
            element.addClass('is-not-visible');
          }, (itemsToHide.length - i) * 25);
        }

        setTimeout(() => {
          itemsToHide.addClass('is-hidden').removeClass('is-not-visible');
          toggleButton.removeClass('is-hidden');
          closeButton.addClass('is-hidden');
        }, itemsToHide.length * 25);
      }, 0);
    });
  }
}